import gql from 'graphql-tag'

export const FRAGMENT_PAGINATOR = gql`
    fragment FragmentPaginator on Paginator {
        totalCount
        hasNextPage
        hasPreviousPage
        search
        query
        filters {
            key
            value
            label
            isApplied
            isVisible
        }
        presets {
            value
            label
            isApplied
            isVisible
            isCustom
        }
        sorts {
            value
            label
        }
        sort {
            value
            label
        }
    }
`
